import { render, staticRenderFns } from "./editCompanyLeaveComponent.vue?vue&type=template&id=2a6c3552&"
import script from "./editCompanyLeaveComponent.vue?vue&type=script&lang=js&"
export * from "./editCompanyLeaveComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports